// extracted by mini-css-extract-plugin
export default {"tableOverflow":"TablePageTemplate_tableOverflow__jjLu4","centered":"TablePageTemplate_centered__U3knl","tablePaginator":"TablePageTemplate_tablePaginator__AxZ31"};